import type { TranslateFn, TranslationExistsFn } from '@/types';

// Lemonway/SEPA errors resolve by direct code lookup; PSP codes (atos, computop,
// payxpert, payzen, verifone) are parsed from `error` and mapped per-PSP catalog.
export const buildTransactionErrorDescriptions = (
  pspName: string,
  error: string | undefined,
  translate: TranslateFn,
  translationExists: TranslationExistsFn
): string[] => {
  const transactionErrorDescriptions = [] as string[];

  if (translationExists(`transactions.errorMessages.lemonway.${error}`)) {
    transactionErrorDescriptions.push(translate(`transactions.errorMessages.lemonway.${error}`));
  } else if (translationExists(`transactions.errorMessages.sepa.${error}`)) {
    transactionErrorDescriptions.push(translate(`transactions.errorMessages.sepa.${error}`));
  } else if (error) {
    const codes = error.split('-');

    switch (pspName) {
      case 'atos':
      case 'atosv2': {
        let codeTypes = ['X', 'Y', 'Z', 'D'];

        if (codes.length === 2) {
          codeTypes = ['D'];
        }

        codeTypes.forEach((codeType, index) => {
          const code = codes[index];
          const description = translationExists(
            `transactions.errorMessages.atos.${codeType}.${code}`
          );

          if (description) {
            transactionErrorDescriptions.push(
              translate(`transactions.errorMessages.atos.${codeType}.${code}`)
            );
          }
        });

        break;
      }
      case 'computop': {
        const code = codes[1];
        const description = translationExists(`transactions.errorMessages.compuTop.${code}`);

        if (description) {
          transactionErrorDescriptions.push(
            translate(`transactions.errorMessages.compuTop.${code}`)
          );
        }

        break;
      }
      case 'payxpert': {
        let code = codes[0];

        if (code.match(/^9[0-9]{1,2}$/)) {
          code = '9**';
        }

        const description = translationExists(`transactions.errorMessages.payxpert.${code}`);

        if (description) {
          transactionErrorDescriptions.push(
            translate(`transactions.errorMessages.payxpert.${code}`)
          );
        }

        break;
      }
      case 'payzen': {
        const codeTypes = ['result', 'error', 'authResult'];

        codeTypes.forEach((codeType, index) => {
          const code = codes[index];
          const description = translationExists(
            `transactions.errorMessages.payzen.${codeType}.${code}`
          );

          if (description) {
            transactionErrorDescriptions.push(
              translate(`transactions.errorMessages.payzen.${codeType}.${code}`)
            );
          }
        });

        break;
      }
      case 'verifone': {
        const code = codes[0];
        const description = translationExists(`transactions.errorMessages.verifone.${code}`);
        if (description) {
          transactionErrorDescriptions.push(
            translate(`transactions.errorMessages.verifone.${code}`)
          );
        }

        break;
      }
      default:
        break;
    }
  }

  return transactionErrorDescriptions;
};
